import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import {
  EmojiEvents,
  Groups,
  School,
  Public,
  WorkspacePremium,
  Star,
} from '@mui/icons-material';

const achievements = [
  {
    icon: <EmojiEvents sx={{ fontSize: 50 }} />,
    number: '15+',
    label: 'Years of Excellence',
    description: 'Serving students since 2009 with consistent track record',
  },
  {
    icon: <Groups sx={{ fontSize: 50 }} />,
    number: '5000+',
    label: 'Students Placed',
    description: 'Successfully placed in top medical colleges worldwide',
  },
  {
    icon: <School sx={{ fontSize: 50 }} />,
    number: '100+',
    label: 'Partner Colleges',
    description: 'Tie-ups with premier medical institutions globally',
  },
  {
    icon: <Public sx={{ fontSize: 50 }} />,
    number: '15+',
    label: 'Countries',
    description: 'Presence across India, Asia, Europe, and Americas',
  },
  {
    icon: <WorkspacePremium sx={{ fontSize: 50 }} />,
    number: '98%',
    label: 'Success Rate',
    description: 'Highest admission success rate in the industry',
  },
  {
    icon: <Star sx={{ fontSize: 50 }} />,
    number: '50+',
    label: 'Awards Won',
    description: 'Recognized for excellence in education consultancy',
  },
];

const AchievementGrid = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 6, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Our{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            Achievements
          </Box>
        </Typography>

        <Grid container spacing={4}>
          {achievements.map((achievement, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: 4,
                  borderRadius: 4,
                  bgcolor: 'white',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
                  },
                }}
              >
                <Box sx={{ color: 'secondary.main', mb: 2 }}>
                  {achievement.icon}
                </Box>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 800, color: 'primary.main', mb: 1 }}
                >
                  {achievement.number}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                  {achievement.label}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {achievement.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AchievementGrid;